import { registerLocaleData } from '@angular/common'
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'
import localeEsCo from '@angular/common/locales/es-CO'
import { CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule, provideZoneChangeDetection } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { BrowserModule } from '@angular/platform-browser'
import { definePreset } from '@primeuix/themes'
import Aura from '@primeuix/themes/aura'
import { NgxDaterangepickerBootstrapModule, NgxDaterangepickerLocaleService } from 'ngx-daterangepicker-bootstrap'
import { providePrimeNG } from 'primeng/config'
import { environment } from '../environments/environment'
import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { SpinnerComponent } from './core/components/spinner/spinner.component'
import { AuthInterceptor } from './core/interceptors/auth.interceptor'
import { RequestInterceptor } from './core/interceptors/request.interceptor'
import { HomeModule } from './home/home.module'
import { MainModule } from './main/main.module'

registerLocaleData(localeEsCo)

const PrimaryPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '{blue.50}',
      100: '{blue.100}',
      200: '{blue.200}',
      300: '{blue.300}',
      400: '{blue.400}',
      500: '{blue.500}',
      600: '{blue.600}',
      700: '{blue.700}',
      800: '{blue.800}',
      900: '{blue.900}',
      950: '{blue.950}',
    },
  },
})

@NgModule({
  declarations: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,

    NgxDaterangepickerBootstrapModule.forRoot(),

    HomeModule,
    MainModule,

    SpinnerComponent,
  ],
  providers: [
    provideZoneChangeDetection(),
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RequestInterceptor,
      multi: true,
    },
    {
      provide: LOCALE_ID,
      useValue: 'es-CO',
    },
    {
      provide: 'BASE_URL',
      useFactory: getBaseUrl,
    },
    providePrimeNG({
      theme: {
        preset: PrimaryPreset,
        options: {
          darkModeSelector: false || 'none',
        },
      },
    }),
    NgxDaterangepickerLocaleService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}

export function getBaseUrl() {
  return environment.servidorApiUrl
}
